import { LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import moment from 'moment-timezone';
import { MomentModule } from 'ngx-moment';

import { TimeAgoPipe } from '@core/time-legacy';
import {
  ComponentVariantTransform,
  RtTooltip,
  TooltipPosition,
  Variants,
} from '@core/user-interface-legacy';

type RtTimeAgoOptions = Parameters<TimeAgoPipe['transform']>[1];

@Component({
  selector: 'rt-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant()',
  },
  imports: [RtTooltip, MomentModule, TimeAgoPipe, LowerCasePipe],
})
export class DateComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['default', 'small', 'large', 'left-align', 'color-red', 'no-wrap'],
  ];
  public readonly variant = input(...ComponentVariantTransform(DateComponent.VARIANTS));
  public readonly time = input<number | string>(undefined!);
  public readonly tiny = input<boolean>(false);
  public readonly tinyWithSuffix = input<boolean>(false);
  public readonly tooltipPosition = input<TooltipPosition>('above');
  public readonly colorDarkest = input<boolean>(false);
  public readonly amDateFormatPattern = input<string>('lll');
  public readonly capitalize = input<boolean>(true);

  @Input() public prefix: string | undefined;
  public timeAgoOptions: RtTimeAgoOptions = undefined;

  public ngOnChanges(): void {
    this.timeAgoOptions = this.getTimeAgoOptions();
  }

  private getTimeAgoOptions(): RtTimeAgoOptions {
    const isFuture = moment(this.time()).isAfter(moment());

    if (this.tiny()) {
      return { omitSuffix: !isFuture, shortWithSuffix: false };
    } else if (this.tinyWithSuffix()) {
      return { omitSuffix: false, shortWithSuffix: true };
    }

    return undefined;
  }
}
